<template>
  <div data-component="Blog">
    <blog-editor-top-panel
      v-model:blog="modelBlog"
      @saved="emit('saved')"
      />

    <blog-editor-settings-droppers
      v-model:blog="modelBlog"
      />

    <blog-contents
      v-model="modelBlog"
      :keeplayout="keeplayout"
      />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['delete','saved'])
const props = defineProps<{
	slug?: string
  keeplayout?: boolean
}>()

const modelBlog = defineModel<Blog|any>()

onMounted(() => {
  methodLoadRenderedBlog()
})

const methodLoadRenderedBlog = async () => {
  const is_editing = modelBlog.value?.is_editing
  const show_as_object = modelBlog.value?.show_as_object

  if (props.slug && !modelBlog.value?.id) {
    return methodRenderBlog(props.slug).then((blog) => {

      modelBlog.value = (blog)
        ? blog
        : {}


      nextTick(() => { // reactivity
        modelBlog.value.is_editing = is_editing
        modelBlog.value.show_as_object = show_as_object
      })
    })
  }
}
</script>
